async function addToCart(variantId) {
    try {
        if (window.sampleLimitValidator) {
            const isAllowed = await window.sampleLimitValidator.validateAddToCart(variantId, 1);
            if (!isAllowed) {
                window.sampleLimitValidator.showModal();
                return;
            }
        } else {
            console.error('Sample limit validator not available - blocking add to cart');
            return;
        }

        const response = await fetch("/cart/add.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!response.ok) {
            throw new Error("Network error");
        }

    } catch (error) {
        console.error("Error adding to cart:", error);
    }
}
